import { render, staticRenderFns } from "./SearchPoiToEditQuiz.vue?vue&type=template&id=6adce51e&scoped=true&"
import script from "./SearchPoiToEditQuiz.vue?vue&type=script&lang=js&"
export * from "./SearchPoiToEditQuiz.vue?vue&type=script&lang=js&"
import style0 from "./SearchPoiToEditQuiz.vue?vue&type=style&index=0&id=6adce51e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adce51e",
  null
  
)

export default component.exports